import { ColumnFilterNew } from './column-filter-new';
import { DateRangeFilterNew } from './date-range-filter-new';
import { GlobalSearchNew } from './global-search-new';
import { PaginationNew } from './pagination-new';
import { SelectedRowCountNew } from './selected-row-count-new';
import { TableNew } from './table-new';

export const DataTableNew = {
  Table: TableNew,
  Pagination: PaginationNew,
  GlobalSearch: GlobalSearchNew,
  SelectedRowCount: SelectedRowCountNew,
  ColumnFilter: ColumnFilterNew,
  DateRangeFilter: DateRangeFilterNew,
};
